import { FC, useEffect, useState } from 'react'
import { UserTable } from '../UserTable'
import { getProfileFollowings } from '../../services/profileService'

interface IFollowersProps {
  address: string
}

export const Followings: FC<IFollowersProps> = (props: IFollowersProps) => {
  const { address } = props
  const [followers, setFollowers] = useState<any[]>([])

  useEffect(() => {
    if (address) {
      getProfileFollowings(address).then((data) => {
        console.log(data)
        setFollowers(data.items)
      })
    }
  }, [address])

  return <UserTable data={followers} />
}
